import { useState } from 'react';

import NavBar from '../navbar';
import ProjectsComponent from './components/Projects';

import GTNComponent from './components/GTN/GTN';
import WordleComponent from './components/Wordle/Wordle';
import RiddleComponent from './components/Riddle/Riddle';
import TicTacToe from './components/TTT/TTT';

import './Home.css';

const HomeComponent = () => {
    const [showGames, setShowGames] = useState(false);

    return (
      <div className='home-page'>
        <NavBar />
        
        <div id='home-content-container'>
            
            <div id="home-content-main">
              
              <ProjectsComponent />
              
              {!showGames ? 
                  <div id='home-games-container'>
                    <div className='games-heading'>
                      <span>02 / PLAYGROUND</span>
                      <h2>Games</h2>
                      <p>A few interactive experiments, built for fun.</p>
                    </div>
                    <button id='projects-open-button' onClick={() => setShowGames(true)} title='Show Games' aria-expanded='false'>Explore games <i className="fa-solid fa-caret-down"/></button>
                  </div>
              : <>
                <div id='home-games-container2'>
                  <div className='games-heading'>
                    <span>02 / PLAYGROUND</span>
                    <h2>Games</h2>
                  </div>
                  <GTNComponent />
                  <WordleComponent />
                  <RiddleComponent />
                  <TicTacToe />
                  <button id='projects-close-button' onClick={() => setShowGames(false)} title='Hide Games' aria-expanded='true'>Close playground <i className="fa-solid fa-caret-up"/></button>
                </div>
                </>
              }
            </div>
            
        </div>
        
      </div>  
    );
};

export default HomeComponent;
